import React from 'react';
import { CardActions } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { Button, Divider, Card, CardContent } from '@occc/ui-design-system';
import { useAppLayoutContextConsumer, Page } from '@occc-app/design-system';
import { Product_Group_Key } from '@occc/graphql';

import CreateProductGroupFormContainer from './CreateProductGroupFormContainer';
import { breadcrumbLinks } from './constants';

import { TotalAvailableRollbackEligibleFormItem } from '../components/TotalAvailableRollbackEligibleFormItem';
import { ProductGroupFormRenderCallback } from '../types';

const PAGE_TITLE = 'Create Product Group';

type CreateProductGroupPageProps = {
  submitCreateProductGroupForm: () => void;
};

const CreateProductGroupPage = ({ submitCreateProductGroupForm }: CreateProductGroupPageProps) => {
  const navigate = useNavigate();

  useAppLayoutContextConsumer(breadcrumbLinks);

  const renderProductGroupFormChildren: ProductGroupFormRenderCallback = (values) => {
    if (values.key !== Product_Group_Key.FuelGradeId) {
      return null;
    }

    return (
      <>
        <Divider sx={{ my: 3 }} />
        <TotalAvailableRollbackEligibleFormItem
          showTARConfigurationFields={!!values.userSelectable}
        />
      </>
    );
  };

  return (
    <Page
      browserTabTitle={PAGE_TITLE}
      containerProps={{ variant: 'md' }}
      pageHeaderProps={{
        title: 'Product Group',
        subtitle:
          'Product Groups represent grouping of products used for Offer creation and Dynamic Audience targeting.',
      }}
    >
      <Card>
        <CardContent>
          <CreateProductGroupFormContainer renderFormChildren={renderProductGroupFormChildren} />
        </CardContent>
        <Divider />
        <CardActions>
          <Button role='button' onClick={() => navigate(-1)}>
            Cancel
          </Button>
          <Button variant='contained' color='primary' onClick={submitCreateProductGroupForm}>
            Create
          </Button>
        </CardActions>
      </Card>
    </Page>
  );
};

export default CreateProductGroupPage;
